import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/(site)/dpa/dpa.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/LandingFooter.jsx");
